export const APP_BAR_HEIGHT = 64

export const CONTAINER_MARGIN_TOP = 16
